<template>
  <div>
    <v-btn icon elevation="0" @click.stop="openMenu" small>
      <v-icon>bhi-dots-vertical</v-icon>
    </v-btn>
    <v-menu
      rounded
      absolute
      offset-x
      transition="false"
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      z-index="101"
    >
      <exercise-action-menu
        v-if="menu == 'browser'"
        :id="id"
        :version="version"
        v-on="$listeners"
        @close="closeMenu"
      />
      <v-list
        v-else-if="menu == 'more' && !readonly"
        class="exercise__more--menu"
      >
        <v-list-item
          v-if="editable"
          link
          dense
          @click="$emit('edit', id, type, version)"
        >
          <v-list-item-icon>
            <v-icon>bhi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Edit
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="movable" link dense @click.stop="openMoveMenu()">
          <v-list-item-icon>
            <v-icon>bhi-folder-move-filled</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Move
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click="$emit('delete', id, type, version)">
          <v-list-item-icon>
            <v-icon>bhi-trash</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Remove
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="duplicable"
          link
          dense
          @click="$emit('duplicate', id)"
        >
          <v-list-item-icon>
            <v-icon>bhi-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Duplicate
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="copyable" link dense @click="$emit('copy', id)">
          <v-list-item-icon>
            <v-icon>bhi-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Copy
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="sharable" link dense @click="$emit('share', id)">
          <v-list-item-icon>
            <v-icon>bhi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Share
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="sharableToAdministration"
          link
          dense
          @click="$emit('share-back', id)"
        >
          <v-list-item-icon>
            <v-icon>bhi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Share
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list
        class="exercise__more--menu"
        v-else-if="menu == 'more' && readonly"
      >
        <v-list-item link dense @click="$emit('import', id)">
          <v-list-item-icon>
            <v-icon>bhi-copy</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Import
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import ExerciseActionMenu from '@/components/exercises/ExerciseActionMenu.vue'

export default {
  name: 'ExerciseMoreMenu',
  components: {
    ExerciseActionMenu,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'EXERCISE',
    },
    version: {
      type: Number,
      default: 0,
    },
    menu: {
      type: [Boolean, String],
      default: false, // other is 'more' or 'browser'
    },
    editable: {
      type: Boolean,
      default: true,
    },
    movable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    duplicable: {
      type: Boolean,
      default: false,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    sharable: {
      type: Boolean,
      default: false,
    },
    sharableToAdministration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      showMenu: false,
    }
  },
  computed: {},
  methods: {
    openMoveMenu() {
      this.showMenu = false
      this.$emit('changeMenuType', 'browser')
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    openMenu(e) {
      e.stopPropagation()
      this.x = e.clientX
      this.y = e.clientY
      this.$emit('changeMenuType', 'more')
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    closeMenu() {
      this.showMenu = false
    },
  },
}
</script>

<style lang="scss">
.exercise {
  &__more {
    width: 32px;
    flex-shrink: 0;
    text-align: center;
    position: absolute;
    top: 4px;
    right: 0;
    opacity: 0;
    -webkit-transition-duration: 150ms;
    -moz-transition-duration: 150ms;
    -ms-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;
    .v-btn {
      padding: 0;
      background: $bh-blue--4;
      .v-icon {
        color: $bh-blue--3;
      }
      &:hover,
      &:focus {
        .v-icon {
          color: $bh-blue;
        }
      }
    }
    &--menu {
      width: 148px;
      .v-list-item__icon {
        margin-right: 12px !important;
        text-align: center;
        display: block;
        .v-icon {
          color: $bh-blue;
        }
      }
      .v-list-item__title {
        font-weight: bold;
        font-size: 1rem;
        color: $bh-blue;
      }
    }
  }
}
</style>
